import type {
    McpToolResponse,
    PatentRouteSearch,
    PatentSearchPlanResult,
    PatentTechnologyRouteResult,
    RuntimeGraphViewResult,
    TechnicalDecompositionResult,
} from '../types';

export const ResearchMcpService = Symbol('ResearchMcpService');

export interface ResearchMcpService {
    decompose(
        query: string,
        signal?: AbortSignal
    ): Promise<McpToolResponse<TechnicalDecompositionResult>>;
    createGraphView(
        nodeId: string,
        signal?: AbortSignal
    ): Promise<McpToolResponse<RuntimeGraphViewResult>>;
    planSearch(
        query: string,
        componentId: string,
        signal?: AbortSignal
    ): Promise<McpToolResponse<PatentSearchPlanResult>>;
    analyzeRoute(
        componentId: string,
        searches: PatentRouteSearch[],
        signal?: AbortSignal
    ): Promise<McpToolResponse<PatentTechnologyRouteResult>>;
}
